import * as React from "react";
import { observer, inject } from "mobx-react";
import SeekerStore from "../../../stores/seekerStore";
import { ILocalization, IStartMenu } from "../../../models/localization";
import { Row, Col } from "react-flexbox-grid";
import Slider from "react-slick";
import * as s from "./factSlider.css";

export class FactSlider extends React.Component<{ store: SeekerStore }, {}> {

  constructor(props: any) {
    super(props);
  }

  render(): JSX.Element {
    const localization: ILocalization = this.props.store.localization.fields;
    const local: IStartMenu = this.props.store.localization.fields.startMenu;

    return (<Col xs={12} className={s.container}>
      <Slider
        dots={true}
        autoplay={true}
        autoplaySpeed={5000}
        draggable={true}
        swipeToSlide={true}
        slidesToScroll={1}
        swipe={true}
        prevArrow={<CustomNoPrevArrow />}
        nextArrow={<CustomNoNextArrow />}>
        <div><p className={s.fact}>{local.fact1}</p></div>
        <div><p className={s.fact}>{local.fact2}</p></div>
        <div><p className={s.fact}>{local.fact3}</p></div>
      </Slider>
    </Col>)
  }
}


function CustomNoPrevArrow(props) {
  const { className, style, onClick } = props
  return (
    <div
      className={s.noPrevArrow}
      style={{
        ...style,
      }}
      onClick={onClick}
    ></div>
  );
}

function CustomNoNextArrow(props) {
  const { className, style, onClick } = props
  return (
    <div
      className={s.noNextArrow}
      style={{
        ...style,
      }}
      onClick={onClick}
    ></div>
  );
}


// WEBPACK FOOTER //
// ./src/components/start/factSlider/index.tsx